<template>
  <transition
    appear
    @enter="cookieEnter"
    @leave="cookieLeave"
  >
    <div
      v-if="show"
      class="c-template c-template--cookie"
      :data-theme="theme"
      style="opacity: 0;"
    >
      <div class="cookie__inner">
        <slot
          v-for="slot in slots"
          :name="slot"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { TimelineLite, Expo } from 'gsap/TweenMax';

export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
    animation: {
      type: Object,
      required: false,
      default() {
        return {
          css: false,
          name: '',
          mode: 'in-out',
          enter: (element, done) => { done(); },
          leave: (element, done) => { done(); },
        };
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },

  methods: {
    cookieEnter(el, done) {
      const tl = new TimelineLite({
        delay: 2,
        onComplete: done,
      });

      tl.add('label')
        .set(el, {
          autoAlpha: 1,
          yPercent: 100,
        }, 'start')
        .set(el.children[0], {
          yPercent: 50,
          autoAlpha: 0,
        }, 'start')
        .to(el, 0.75, {
          yPercent: 0,
          ease: Expo.easeOut,
        }, 'start+=0.5')
        .to(el.children[0], 0.75, {
          yPercent: 0,
          autoAlpha: 1,
          ease: Expo.easeOut,
        }, 'start+=0.7');
    },
    cookieLeave(el, done) {
      const tl = new TimelineLite({
        onComplete: done,
      });

      tl.add('label')
        .to(el.children[0], 0.5, {
          autoAlpha: 0,
          ease: Expo.easeOut,
        }, 'start+=0.2')
        .to(el, 0.5, {
          yPercent: 100,
          ease: Expo.easeOut,
        }, 'start+=0.5');
    },
  },
};
</script>

<style lang="scss" scoped>
.c-template.c-template--cookie {
  position: fixed;
  box-sizing: border-box;
  bottom: 0;
  width: 100%;

  background: $color-white;
  padding: 30px 20px 30px 20px;

  color: $color-black;

  z-index: 105;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  font-style: italic;

  border-top: 1px solid RGB($color-dark-light);
  backface-visibility: hidden;
  overflow: hidden;

  @include mq(ipadL) {
    padding: 30px 0 30px 40px;
    right: 12.5vw;

    width: auto;
    max-width: 480px;
  }

  & ::v-deep a {
    position: relative;
    display: inline-block;
    color: $color-black;

    &::after {
      content: '';
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 2px;
      height: 1px;
      background: $color-black;
    }
  }
}
.cookie__inner {
  position: relative;
  grid-area: cookie;

  backface-visibility: hidden;

  @include mq(ipadP) {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
